var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenTypeModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "52px",
    viewBox: "0 0 28 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4F167FEB-796A-4AC9-97BB-8FD782ED8E5E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-534.000000, -4586.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modal",
    transform: "translate(535.000000, 4587.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-19",
    stroke: "#979797",
    strokeWidth: 0.3,
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 26,
    height: 50,
    rx: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-38",
    transform: "translate(0.500000, 1.414214)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 8.67361738e-17,
    y1: 4.08578644,
    x2: 25,
    y2: 4.08578644,
    id: "Line-2-Copy-6",
    stroke: "#EEEEEE",
    strokeWidth: 0.3,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-19",
    fill: "#EEEEEE",
    x: 1.5,
    y: 7.58578644,
    width: 22,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-47",
    fill: "#EEEEEE",
    x: 1.5,
    y: 13.5857864,
    width: 22,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-67",
    fill: "#EEEEEE",
    x: 1.5,
    y: 19.5857864,
    width: 22,
    height: 5,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-48",
    fill: "#464646",
    x: 1.5,
    y: 27.5857864,
    width: 22,
    height: 3,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.32842712,0.414213562 C2.3836556,0.414213562 2.42842712,0.458985087 2.42842712,0.514213562 L2.42742712,1.31421356 L3.22842712,1.31421356 C3.2836556,1.31421356 3.32842712,1.35898509 3.32842712,1.41421356 C3.32842712,1.46944204 3.2836556,1.51421356 3.22842712,1.51421356 L2.42742712,1.51421356 L2.42842712,2.31421356 C2.42842712,2.36944204 2.3836556,2.41421356 2.32842712,2.41421356 C2.27319865,2.41421356 2.22842712,2.36944204 2.22842712,2.31421356 L2.22742712,1.51421356 L1.42842712,1.51421356 C1.37319865,1.51421356 1.32842712,1.46944204 1.32842712,1.41421356 C1.32842712,1.35898509 1.37319865,1.31421356 1.42842712,1.31421356 L2.22742712,1.31421356 L2.22842712,0.514213562 C2.22842712,0.458985087 2.27319865,0.414213562 2.32842712,0.414213562 Z",
    id: "Combined-Shape-Copy",
    fill: "#000000",
    transform: "translate(2.328427, 1.414214) rotate(45.000000) translate(-2.328427, -1.414214) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenTypeModal);
export default __webpack_public_path__ + "static/media/ScreenType-Modal.77396f4d05c2868324f9d3efbcdd5ca5.svg";
export { ForwardRef as ReactComponent };